export const ComponentEnum = Object.freeze(
  {
    ShippingOptions: 1,
    Incoterm: 2,
    ShippingFeatures: 3,
    RouteCharacteristics: 4,
    ComponentSelection: 5,
    WarehouseLogistics: 6,
    ShippingLogistics: 7,
    ReceptionLogistics: 8,
    FinancialAdministrativeCosts: 9,
    FinancialAdministrativeCostsImport: 10,
    InsuranceAndExtras: 11,
    InsuranceAndExtrasImport: 12,
    InlandTransportationParent: 13,
    InlandTransportation: 14,
    InlandTransportationImport: 15,
    ProcessingAndFees: 16,
    AdministrationFees: 17,
    ProceduresAndPermits: 18,
    CustomClearanceImport: 19,
    TaxesAndFees: 20,
    InternationalFreight: 21,
    TerminalManagement: 22,
    TerminalManagementImport: 23,
    AirportManagement: 24,
    AirportManagementImport: 25,
    InternationalTransport: 26,
    Results: 27
  }
)
